<template>
    <div class="user-left-menu-container">
        <ul class="left-menu-list">
            <li v-for="(items, i) in leftMenuList" :key="i">
                <div class="menu-item" @click="checkMenuItem(i)" :class="{active: firstActive == i}">
                    <div :class="'icon-img icon'+i"></div>
                    <!-- <i :class="'icon iconfont ' + items.icon"></i> -->
                    <span>{{items.name}}</span>
                </div>
                <ul class="menu-child-list" :class="{childshow: (firstActive == i && firstActive != 0) || childShow == i}">
                    <li v-for="(item, j) in items.children" :key="j" :class="{cactive: firstActive == i && secondActive == j}" 
                        @click="checkChildMenuItem(i, j)">{{item.name}}</li>
                    <div class="child-active" :style="'top:'+(17+48*secondActive)+'px;'" 
                        v-show="firstActive == i && secondActive>-1"></div>
                </ul>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'UserLeftMenu',
    data() {
        return {
            leftMenuList: [],
            childShow: -1
        }
    },
    computed: {
        firstActive() {
            return this.$store.state.userLeftStatus.menuIndex;
        },
        secondActive() {
            return this.$store.state.userLeftStatus.childIndex;
        }
    },
    created() {
        this.getLeftMenuList();
        this.getSessionData();
    },
    mounted() {
        this.setMenuOpen();
    },
    methods: {
        /**
         * @function getLeftMenuList 获取左侧菜单数据
         */
        getLeftMenuList() {
            this.leftMenuList = [
                {
                    id: 1,
                    name: '主页',
                    icon: 'https://cdn.bigbays.cn/user/icon-img/main-page-icon.png',
                    icon_active: 'https://cdn.bigbays.cn/user/icon-img/main-page-icon-active.png',
                    path: '/userNewDynamicP',
                    children: []
                },
                {
                    id: 2,
                    name: '个人中心',
                    icon: 'https://cdn.bigbays.cn/user/icon-img/personal-center-icon.png',
                    icon_active: 'https://cdn.bigbays.cn/user/icon-img/personal-center-icon-active.png',
                    children: [
                        { id: 4, name: '账号管理', path: '/userIdManageP' },
                        { id: 5, name: '我的粉丝', path: '/userMyFansP' },
                        { id: 6, name: '我的关注', path: '/userMyFocusP' },
                        { id: 7, name: '我的收藏', path: '/userMyCollectP' },
                        // { id: 8, name: '我的评论', path: '/userMyCommentP' },
                        { id: 8, name: '我的消息', path: '/userMyMessageP' }
                    ]
                },
                {
                    id: 3,
                    name: '创作中心',
                    icon: 'https://cdn.bigbays.cn/user/icon-img/creation-center-icon.png',
                    icon_active: 'https://cdn.bigbays.cn/user/icon-img/creation-center-icon-active.png',
                    children: [
                        { id: 9, name: '投稿', path: '/userContributeP' },
                        { id: 10, name: '授权申请', path: '/userAccreditApplyP' },
                        { id: 11, name: '文章审核', path: '/userArticleAuditP' },
                        { id: 12, name: '公众号授权', path: '/userMpwxAccreditP' },
                        { id: 13, name: '创作', path: '/userFalseOriginalP' },
                        { id: 14, name: '内容管理', path: '/userContentManageP' },
                        { id: 15, name: '维权计划', path: '/userSafeguardRightPlanP' }
                    ]
                }
            ];
        },
        getSessionData() {
            let data = window.sessionStorage.getItem('userLeftStatus');
            if(data) {
                let _data = JSON.parse(data);
                this.$store.commit('setUserLeftStatus', _data);
            }
        },
        /**
         * @function setMenuOpen 设置左侧菜单展开项
         */
        setMenuOpen() {
            this.childShow = this.secondActive > -1 && this.firstActive != 0 ? this.firstActive : -1;
        },
        /**
         * @function checkMenuItem 点击左侧菜单项
         * @param { number } i 点击项
         */
        checkMenuItem(i) {
            if(this.leftMenuList[i].children.length > 0) {
                this.childShow = this.childShow > -1 && this.childShow == i ? -1 : i;
            } else {
                this.childShow = -1;
                this.$store.commit('setUserLeftStatus', { menuIndex: 0, childIndex: -1 });
                this.$router.push({path: this.leftMenuList[i].path});
            }
        },
        checkChildMenuItem(i, j) {
            let current = this.leftMenuList[i].children[j];
            if(current.id !== 9 && current.id !== 13) {
                this.$store.commit('setUserLeftStatus', { menuIndex: i, childIndex: j });
            }
            this.$router.push({path: current.path});
        }
    }
}
</script>
<style lang="scss" scoped>
@import './UserLeftMenu.scss';
</style>


// WEBPACK FOOTER //
// src/components/pc/common/user-left-menu/UserLeftMenu.vue